export * from './powerbi-embed.model';
export * from './powerbi-overall-chart.model';
